export { default } from './Deals.container';
